import AdminPermissionDataTable from '../../../features/system/admin-permission/components/AdminPermissionDataTable'
import AdminPermissionHeader from '../../../features/system/admin-permission/components/AdminPermissionHeader'

export default function AdminPermissionTestPage() {
  return (
    <>
      <AdminPermissionHeader />
      <AdminPermissionDataTable />
    </>
  )
}
